import { Link } from "@/i18n/LocaleLink";
import { Feather, BookOpen, CalendarDays, FileDown, MessagesSquare } from "lucide-react";

const links = [
  { to: "/admin/letter", label: "Letter", icon: Feather, testid: "admin-nav-letter" },
  { to: "/admin/booklet", label: "Booklet", icon: BookOpen, testid: "admin-nav-booklet" },
  { to: "/admin/bookings", label: "Bookings", icon: CalendarDays, testid: "admin-nav-bookings" },
  { to: "/admin/guides", label: "Guides", icon: FileDown, testid: "admin-nav-guides" },
  { to: "/admin/enquiries", label: "Enquiries", icon: MessagesSquare, testid: "admin-nav-enquiries" },
];

export const AdminNav = ({ current }) => (
  <nav className="flex flex-wrap gap-2" data-testid="admin-nav" aria-label="Admin pages">
    {links.map(({ to, label, icon: Icon, testid }) => (
      <Link
        key={to}
        to={to}
        data-testid={testid}
        className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs tracking-[0.15em] uppercase transition-colors duration-300 ${
          current === to ? "border-clay bg-clay text-cream" : "border-ink/20 text-soft hover:border-clay hover:text-ink"
        }`}
      >
        <Icon size={13} strokeWidth={1.5} />
        {label}
      </Link>
    ))}
  </nav>
);
